export default {"src":"/_next/static/media/0xb4e16d0168e52d35cacd2c6185b44281ec28c9dc.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};